<template>
  <v-btn :href="href" download="banner.html" outlined color="teal" small class="download-btn white--text">            
      <v-icon dark small>mdi-pencil</v-icon>
      Download
  </v-btn>
</template>

<script>
import { bannerHtml } from '@/utility/affiliate-utility'

export default {
  name: 'DownloadBanner',
  props: ['banner'],
  computed: {
    href () {
      return 'data:text/html;charset=utf-8,' + encodeURIComponent(bannerHtml(this.banner))
    }
  }
}
</script>
